import React, { useState, useEffect, useRef } from "react";
import Header from "../Section/Header";

import { Calendar, Clock, Calendar as CalendarIcon, X } from "lucide-react";
import Footer from "../Section/Footer";
import { Modal } from "react-bootstrap";
import sucess_gif from "../../Assests/sucess_gif.gif";
import {
  update_profile_url,
  server_post_data,
  view_subjecsts,
} from "../../ServiceConnection/serviceconnection";
import { formatDOB } from "../../CommonJquery/CommonJquery";
import { CustomAlert } from "../../CommonJquery/CustomAlert";
import Loader from "../Section/Loader";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
export default function Profile() {
  const timeInputRef = useRef(null);
  const inputRef = useRef(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    dob: null,
    time: "",
    place: "",
    language: "english",
    saveKundali: true,
    latitude: "",
    longitude: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [ActiveUpdateBtn, setActiveUpdateBtn] = useState(false);
  console.log("form_lo", formData.place);
  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Please enter your full name.";
    if (!formData.email) newErrors.email = "Please select your email.";
    if (!formData.dob) newErrors.dob = "Please select your birth date.";
    if (!formData.time) newErrors.time = "Please select your birth time.";
    if (!formData.place.trim())
      newErrors.place = "Please enter your birth place.";
    if (!formData.language) newErrors.language = "Please select your language.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  useEffect(() => {
    if (!window.google) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: ["(cities)"],
        componentRestrictions: { country: "in" },
      }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      const formatted = place.formatted_address || place.name || "";

      const lat = place.geometry?.location?.lat();
      const lng = place.geometry?.location?.lng();

      setFormData((prev) => ({
        ...prev,
        place: formatted,
        latitude: lat ? lat.toFixed(6) : "",
        longitude: lng ? lng.toFixed(6) : "",
      }));

      setErrors((prev) => ({ ...prev, place: "" }));
    });

    return () => {
      window.google.maps.event.clearInstanceListeners(autocomplete);
    };
  }, []);

  const splitPlace = (placeString) => {
    if (!placeString) return { city: "", state: "", country: "" };

    const parts = placeString.split(",").map((part) => part.trim());

    return {
      city: parts[0] || "",
      state: parts[1] || "",
      country: parts[2] || "",
    };
  };

  const handleDynamic = async (type) => {
    setIsLoading(true);
    const { city, state, country } = splitPlace(formData.place);
    const dobDate = new Date(formData.dob);
    const dobYear = dobDate.getFullYear();
    const dobMonth = String(dobDate.getMonth() + 1).padStart(2, "0");
    const dobDay = String(dobDate.getDate()).padStart(2, "0");
    const fd = new FormData();
    fd.append("full_name", formData.name);
    fd.append("user_email", formData.email);
    fd.append("user_dob", `${dobYear}-${dobMonth}-${dobDay}`);
    fd.append("user_time", formData.time);
    fd.append("city_name", city);
    fd.append("state_name", state);
    fd.append("country_name", country);

    fd.append("latitude_data", formData.latitude);
    fd.append("longitude_data", formData.longitude);
    await server_post_data(update_profile_url, fd)
      .then((Response) => {
        setIsLoading(false);
        setShowSuccessModal(true);
        setActiveUpdateBtn(false);

        masterDataGet();
        setTimeout(() => {
          setShowSuccessModal(false);
        }, 2000);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      console.log("Submitted:", formData);

      handleDynamic();
    }
  };
  useEffect(() => {
    masterDataGet();
  }, []);
  const masterDataGet = async () => {
    setIsLoading(true);
    const fd = new FormData();
    fd.append("sub_id", 0);
    fd.append("cat_id", 0);
    fd.append("thread_id", 0);
    fd.append("load_more", 0);
    fd.append("total_load", 0);
    fd.append("flag", 10);

    await server_post_data(view_subjecsts, fd)
      .then(async (Response) => {
        setIsLoading(false);
        let data = Response.split("~@~");
        if (parseInt(data[0]) === 1) {
          CustomAlert("Error", data[1]);
        } else {
          let astroData = JSON.parse(
            JSON.parse(data[1])[0]["get_data_subs"]
          )[0];
          console.log("astroData", astroData);
          setFormData({
            name: astroData.full_name,
            email: astroData.user_email,
            dob: astroData.user_dob,
            time: astroData.user_time,
            place: `${astroData.city_name} ${astroData.state_name} ${astroData.country_name}`,
            language: "english",
            saveKundali: true,
          });
          setActiveUpdateBtn(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const openTimePicker = () => {
    if (timeInputRef.current) {
      timeInputRef.current.showPicker();
    }
  };

  return (
    <>
      <Header />
      {isLoading && <Loader />}
      <div className="bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 bg-[length:300%_300%] animate-gradient-flow">
        <section className="max-w-[1050px] mx-auto py-10 px-4">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">
              📝 Profile
            </h2>
            <p className="text-lg text-purple-300">
              Update your personal details to keep your profile up to date.
            </p>
          </div>

          <div className="rounded-lg text-card-foreground shadow-sm bg-slate-800/50 border border-purple-500/30 py-4 px-3  backdrop-blur-sm">
            <div className="p-6 pt-0">
              <form className="space-y-6">
                {/* Full Name */}
                <div className="space-y-1">
                  <label
                    htmlFor="name"
                    className="text-sm font-medium text-purple-200"
                  >
                    Full Name <span className="text-red-400">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    placeholder="Enter your full name"
                    className="h-11 w-full rounded-md px-3 py-3 bg-slate-700/50 text-[var(--light-purple)] placeholder-[var(--light-purple)] border"
                    style={{
                      borderColor: "var(--primary-border)",
                      borderWidth: "1.5px",
                    }}
                    value={formData.name}
                    onChange={(e) => {
                      setFormData({ ...formData, name: e.target.value });
                      setErrors({ ...errors, name: "" });
                      setActiveUpdateBtn(true);
                    }}
                  />
                  {errors.name && (
                    <span className="text-sm text-red-400">{errors.name}</span>
                  )}
                </div>

                {/* Gender */}
                <div className="space-y-1 relative">
                  <label
                    htmlFor="email"
                    className="text-sm font-medium text-purple-200"
                  >
                    Email <span className="text-red-400">*</span>
                  </label>
                  <input
                    type="text"
                    id="email"
                    placeholder="Enter your full name"
                    className="h-11 w-full rounded-md px-3 py-3 bg-slate-700/50 text-[var(--light-purple)] placeholder-[var(--light-purple)] border"
                    style={{
                      borderColor: "var(--primary-border)",
                      borderWidth: "1.5px",
                    }}
                    value={formData.email}
                    onChange={(e) => {
                      setFormData({ ...formData, email: e.target.value });
                      setErrors({ ...errors, email: "" });
                      setActiveUpdateBtn(true);
                    }}
                  />
                  {errors.email && (
                    <span className="text-sm text-red-400">{errors.email}</span>
                  )}
                </div>

                {/* Date of Birth */}
                <div className="space-y-1 cusm_date_picker_container">
                  <label
                    htmlFor="dob"
                    className="text-sm font-medium text-purple-200"
                  >
                    Date of Birth <span className="text-red-400">*</span>
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      format="DD/MM/YYYY"
                      value={formData.dob ? dayjs(formData.dob) : null}
                      onChange={(date) => {
                        setFormData({ ...formData, dob: date });
                        setErrors({ ...errors, dob: "" });
                        setActiveUpdateBtn(true);
                      }}
                  
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          placeholder: "Select your birth date",
                          variant: "outlined",
                          className: "custom-datepicker",
                        },
                      }}
                    />
                  </LocalizationProvider>

                  {errors.dob && (
                    <span className="text-sm text-red-400 error_SPAN">
                      {errors.dob}
                    </span>
                  )}
                </div>
            

                {/* Time of Birth */}
                <div className="space-y-1 timeofBirth" onClick={openTimePicker}>
                  <label
                    htmlFor="time"
                    className="text-sm font-medium text-purple-200"
                  >
                    Time of Birth <span className="text-red-400">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type="time"
                      id="time"
                      ref={timeInputRef}
                      className="appearance-none h-11 w-full rounded-md px-4 py-2 pr-10 bg-slate-700/50 text-[var(--light-purple)] border"
                      style={{
                        borderColor: "var(--primary-border)",
                        borderWidth: "1.5px",
                      }}
                      value={formData.time}
                      onChange={(e) => {
                        setFormData({ ...formData, time: e.target.value });
                        setErrors({ ...errors, time: "" });
                        setActiveUpdateBtn(true);
                      }}
                    />
                    <Clock
                      size={18}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-purple-300 pointer-events-none"
                    />
                  </div>
                  {errors.time && (
                    <span className="text-sm text-red-400">{errors.time}</span>
                  )}
                </div>

                {/* Place of Birth */}
                <div className="space-y-1">
                  <label
                    htmlFor="place"
                    className="text-sm font-medium text-purple-200"
                  >
                    Place of Birth <span className="text-red-400">*</span>
                  </label>
                  <input
                    ref={inputRef}
                    type="text"
                    id="place"
                    placeholder="City, State, Country"
                    className="h-11 w-full rounded-md px-4 py-2 bg-slate-700/50 text-[var(--light-purple)] placeholder-[var(--light-purple)] border"
                    style={{
                      borderColor: "var(--primary-border)",
                      borderWidth: "1.5px",
                    }}
                    value={formData.place}
                    onChange={(e) => {
                      setFormData({ ...formData, place: e.target.value });
                      setErrors({ ...errors, place: "" });
                      setActiveUpdateBtn(true);
                    }}
                  />
                  {errors.place && (
                    <span className="text-sm text-red-400">{errors.place}</span>
                  )}
                </div>
                {/* {formData.latitude?.length > 0 &&
                  formData.longitude?.length > 0 && (
                    <div className="flex items-center gap-4">
                      <div className="text-[12px] font-medium text-purple-200">
                        Latitude: {formData.latitude}
                      </div>
                      <div className="text-[12px] font-medium text-purple-200">
                        Longitude: {formData.longitude}
                      </div>
                    </div>
                  )} */}

                {/* Action Buttons */}
                <div className="pt-4 space-y-4">
                  <button
                    disabled={!ActiveUpdateBtn}
                    type="button"
                    className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-primary hover:bg-primary/90 h-10 px-4 py-4 w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-[var(--white)] font-semibold rounded-full"
                    onClick={handleSubmit}
                  >
                    Update Profile
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
        backdrop="static"
        keyboard={false}
        className="custom-modal-success"
      >
        <Modal.Body className="text-center bg-slate-800 text-white p-0 rounded-lg ">
          <div className="flex flex-col items-center justify-center px-3 py-4 text-center relative">
            <X
              size={28}
              className="cursor-pointer absolute right-[0.2rem] md:right-[-2rem] top-[-2.2rem] md:top-[-2rem] rounded-full bg-white text-black p-[5px] shadow-md hover:scale-110 transition-transform duration-200"
              onClick={() => setShowSuccessModal(false)}
            />

            <div className="mb-4">
              <img
                src={sucess_gif}
                alt="Success"
                className="h-[180px] w-auto"
              />
            </div>
            <h5 className="text-[22px] font-bold text-green-400 mb-[12px]">
              Profile Updated Successfully!
            </h5>
            <p className="text-[14px] text-white/80 max-w-md mb-4">
              Your profile information has been saved. Thank you for keeping
              your details up-to-date. You can now continue using the platform
              with your updated profile.
            </p>
          </div>
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
}
